// @flow

import {waitAndReturn} from 'app/demo/utils';

import {ListResponseType} from 'sweet-types';

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/ban-types */

export const subscriptionStatusFetcher = (
  object_id: number,
  content_type: 'procedure' | 'proceduregroup' | 'policy' | 'tasktemplate'
): Promise<ListResponseType<unknown>> =>
  waitAndReturn({
    count: 0,
    next: null,
    previous: null,
    results: [],
    num_pages: 1,
  });

export const unsubscribeFetcher = (url: string): Promise<unknown> =>
  waitAndReturn({});

export const subscribeFetcher = (
  object_id: number,
  content_type: 'procedure' | 'proceduregroup' | 'policy' | 'tasktemplate'
): Promise<unknown> =>
  waitAndReturn({
    content_type,
    object_id,
    url: '/api/v1/thread/1/',
  });

/* eslint-enable */
